<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->

      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({
                      name: 'RegionalManagerUsersLocalManagersCreate',
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("newLocalManager") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
          </template>

          <template v-slot:item.data_cadastro="{ item }">
            <div class="caption">
              {{ item.data_cadastro | dateFormat }}
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <v-icon :color="colorStatus(item.status)" size="16">
              mdi-circle
            </v-icon>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  'regionalManager/locals/getLocal'
                )
              "
            >
              <v-icon color="green" small>mdi-account-multiple</v-icon>
              {{ item.name_local }}
            </a>
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      $profile.showProfileDrawer(
                        item.id,
                        'regionalManager/locals/getLocal'
                      )
                    "
                  >
                    <v-icon>mdi-account-multiple</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("profile") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      $router.push({
                        name: 'RegionalManagerFinancialApuration',
                        query: {
                          id_local: item.id,
                        },
                      })
                    "
                  >
                    <!-- <v-icon>mdi-cash-usd-outline</v-icon> -->
                    <v-icon>mdi-currency-usd</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("accounting") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name: 'RegionalManagerUsersLocalManagersEdit',
                          params: { id: item.id },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-manager-users-local-manager-list",
  components: {
    HeaderPrint,
  },
  data: () => ({
    items: [],
    search: "",
  }),

  mounted() {
    this.getLocalsList();
  },
  computed: {
    refresh() {
      return this.$store.getters.getRefresh;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("idLabel"), value: "id" },
        { text: this.$t("statusLabel"), value: "status" },
        { text: this.$t("name"), value: "name_local" },
        { text: this.$t("labelLogin"), value: "login_local" },
        { text: this.$t("registrationDate"), value: "data_cadastro" },
        {
          text: this.$t("actionsLabel"),
          value: "action",
          align: "center d-print-none",
        },
      ];
    },
  },
  watch: {
    refresh(val) {
      val && this.getLocalsList();
      this.$store.commit("setRefresh", false);
    },
    // 3. Setup Filters
    saveFilters(val) {
      val && this.getLocalsList();
    },
  },
  methods: {
    resetPage() {
      this.search = "";
    },

    async getLocalsList() {
      this.resetPage();
      const post = { status: this.status };

      const request = await this.$request.post(
        "/regionalManager/locals/list",
        post
      );

      this.items = request.length == 0 ? [] : request.dados;
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
    // handle color status
    colorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },
  },
  filters: {
    dateFormat: function(val) {
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
